import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { Select, Icon } from 'antd';

import PopoverGeneric from '../commons/popoverGeneric';

const Option = Select.Option;

const titolContingutPopoverEscalaBeaufort =
  'Les categories del vent es defineixen a partir de velocitats mitjanes en 10 minuts:';
const contingutPopoverEscalaBeaufort = [
  'Calma (0): velocitats de fins a 0,5 m/s.',
  'Fluix (1-3): velocitats superiors a 0,5 m/s i fins a 5 m/s.',
  'Moderat (4-5): velocitats superiors a 5 m/s i fins a 10 m/s.',
  'Fort (6-8): velocitats superiors a 10 m/s i fins a 20 m/s.',
  'Molt fort (9-12): velocitats superiors a 20 m/s i fins a 35 m/s.',
  'Extremament fort (> 12): velocitats superiors a 35 m/s.'
];

const shaDeDeshabilitarElComponent = variable => {
  const { esPotEditar, esValorCalculAutomatic } = variable;
  const esNoEditable =
    typeof esPotEditar === 'undefined' ? false : !esPotEditar;
  return esNoEditable || esValorCalculAutomatic;
};

class ObservacioIntroduccioVariableLlista extends Component {
  renderEscalaBeaufortSiVariableVelocitatVent(idVariable) {
    const ID_VARIABLE_VELOCITAT_VENT = 83;

    if (idVariable === ID_VARIABLE_VELOCITAT_VENT) {
      const contingutPopover = (
        <div className="escala-beaufort">
          <p>{titolContingutPopoverEscalaBeaufort}</p>
          <ul>
            {contingutPopoverEscalaBeaufort.map((contingut, index) => (
              <li key={index}>{contingut}</li>
            ))}
          </ul>
        </div>
      );

      const icona = (
        <Icon
          type="question-circle"
          className="observacio-introduccio-popover"
          style={{ color: '#108ee9' }}
        />
      );

      return (
        <PopoverGeneric
          titolPopover="Escala de Beaufort"
          contingutPopover={contingutPopover}
          elementBase={icona}
        />
      );
    }
  }

  condicionsFiltratgeSelect(input, option) {
    return (
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    );
  }

  renderOpcionsLlista(opcions) {
    return opcions.map((opcio, index) => {
      return (
        <Option key={opcio.valor + '-' + index} value={opcio.valor}>
          {opcio.label}
        </Option>
      );
    });
  }

  render() {
    const variable = this.props.variable;
    const missatgeLlistaBuida = "No s'han trobat opcions";
    const valor = variable.hasOwnProperty('valorNou')
      ? variable.valorNou
      : variable.valor;
    /*Att. mode => combobox: varies opcions, només pots seleccionar 1,
                       tags: varies opcions, pots seleccionar varies, pots afegir opcions
                       multiple: varies opcions, pots seleccionar varies*/
    const mode = variable.multiple ? 'multiple' : null;

    const deshabilitarSelect = shaDeDeshabilitarElComponent(variable);

    return (
      <div
        className="observacio-introduccio-variable"
        id={'selector-scrollable' + variable.idVariable}
      >
        <span className="observacio-introduccio-variable-nom">
          {variable.nomVariable}
        </span>
        <span>
          <Select
            mode={mode}
            notFoundContent={missatgeLlistaBuida}
            defaultValue={valor}
            className="observacio-introduccio-variable-llista-select"
            getPopupContainer={() =>
              document.getElementById(
                'selector-scrollable' + variable.idVariable
              )
            }
            filterOption={this.condicionsFiltratgeSelect}
            onChange={value => {
              this.props.onChangeValorVariable(value);
            }}
            allowClear
            disabled={deshabilitarSelect}
          >
            {this.renderOpcionsLlista(variable.valorsPossibles)}
          </Select>
          &nbsp;{variable.unitats}&nbsp;
          {this.renderEscalaBeaufortSiVariableVelocitatVent(
            variable.idVariable
          )}
        </span>
      </div>
    );
  }
}

ObservacioIntroduccioVariableLlista.propTypes = {
  variable: PropTypes.object,
  onChangeValorVariable: PropTypes.func
};

export default ObservacioIntroduccioVariableLlista;



// WEBPACK FOOTER //
// ./src/components/observacio/observacioIntroduccioVariableLlista.js